import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden", "visible"]
  
  reveal() {
    this.hiddenTarget.classList.add("hidden")
    this.visibleTarget.classList.remove("hidden")
  }
  
  hide() {
    this.visibleTarget.classList.add("hidden")
    this.hiddenTarget.classList.remove("hidden")
  }
}
